import { render, staticRenderFns } from "./CatchUps.vue?vue&type=template&id=91d186c6&scoped=true"
import script from "./CatchUps.vue?vue&type=script&lang=js"
export * from "./CatchUps.vue?vue&type=script&lang=js"
import style0 from "./CatchUps.vue?vue&type=style&index=0&id=91d186c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d186c6",
  null
  
)

export default component.exports